import * as AppRoutesName from 'src/utils/constants/app-routes-name'
import * as AppRoutesUrl from 'src/utils/constants/app-routes'
import { FEATURE_NAMES } from 'modules/feature-flag/constants.js'

import ROUTES from '../constants/app-routes'
import ICONS from '../constants/icons'

const allRoles = ['foundryAdmin', 'foundryUser', 'foundryFontManager', 'foundrySalesManager', 'foundrySupport']
const allNonSupportRoles = allRoles.filter(role => role !== 'foundrySupport')

export const sideNavigationMenu = [
  // Applications
  {
    name: 'Applications',
    title: 'components.general.fou_side_navigation.applications',
    uri: ROUTES.APPLICATIONS.path,
    relatedRouteName: [ROUTES.APPLICATIONS.name, AppRoutesName.APPLICATION_PREVIEW],
    linkedRoutes: [ROUTES.APPLICATIONS.name, AppRoutesName.APPLICATION_PREVIEW],
    icon: ICONS.APPLICATIONS,
    isOpen: false,
    roles: ['foundrySupport'],
    tabPermission: 'applications'
  },
  // Dashboard
  {
    name: 'Dashboard',
    title: 'components.general.fou_side_navigation.dashboard',
    uri: ROUTES.DASHBOARD.path,
    relatedRouteName: [ROUTES.DASHBOARD.name, ROUTES.MANAGE_FONTS.name, AppRoutesName.SUBMISSIONS_CREATE, AppRoutesName.SUBMISSIONS_CORRECT, AppRoutesName.SUBMISSIONS_DETAILS, AppRoutesName.SUBMISSIONS_SUPPORT_EDIT, AppRoutesName.SUBMISSIONS_FORMAT_LIVE_EDIT_DETAILS, AppRoutesName.SUBMISSIONS_FORMAT_DETAILS, AppRoutesName.SUBMISSIONS_SUPPORT_REVIEW, AppRoutesName.SUBMISSION_SUCCESS],
    linkedRoutes: [ROUTES.DASHBOARD.name],
    icon: ICONS.DASHBOARD,
    isOpen: false,
    roles: allRoles,
    tabPermission: ['submissions', 'bundles', 'promotions', 'salesReport', 'payments', 'agreements', 'Foundry Profile', 'User Management'],
    disabledIfGracePeriodExpired: true
  },
  // Manage Fonts -- Submission, Promotions and Bundles
  {
    name: 'Manage Fonts',
    title: 'components.general.fou_side_navigation.manage_fonts.title',
    relatedRouteName: [ROUTES.MANAGE_FONTS.name, ROUTES.PROMOTION.name, ROUTES.BUNDLE.name],
    linkedRoutes: [ROUTES.MANAGE_FONTS.name, AppRoutesName.SUBMISSIONS_CREATE, AppRoutesName.SUBMISSIONS_CORRECT, AppRoutesName.SUBMISSIONS_DETAILS, AppRoutesName.SUBMISSIONS_SUPPORT_EDIT, AppRoutesName.SUBMISSIONS_FORMAT_LIVE_EDIT_DETAILS, AppRoutesName.SUBMISSIONS_FORMAT_DETAILS, AppRoutesName.SUBMISSIONS_SUPPORT_REVIEW, AppRoutesName.SUBMISSION_SUCCESS, AppRoutesName.PROMOTION_DASHBAORD, AppRoutesName.NEW_PROMOTION, AppRoutesName.EDIT_PROMOTION, AppRoutesName.VIEW_PROMOTION, AppRoutesName.PROMOTION_SUCCESS, AppRoutesName.BUNDLE_DASHBOARD, AppRoutesName.BUNDLE_SUBMISSION_DRAFT, AppRoutesName.BUNDLE_SUCCESS, AppRoutesName.REACTIVATE_FONT_FAMILIES],
    icon: ICONS.SUBMISSIONS,
    isOpen: false,
    roles: allNonSupportRoles,
    tabPermission: ['submissions', 'promotions', 'bundles'],
    disabledIfContractTermination: true,
    childRoutes: [
      {
        title: 'components.general.fou_side_navigation.manage_fonts.submissions',
        uri: ROUTES.MANAGE_FONTS.path,
        routeName: ROUTES.MANAGE_FONTS.name,
        linkedRoutes: [ROUTES.MANAGE_FONTS.name, AppRoutesName.SUBMISSIONS_CREATE, AppRoutesName.SUBMISSIONS_CORRECT, AppRoutesName.SUBMISSIONS_DETAILS, AppRoutesName.SUBMISSIONS_SUPPORT_EDIT, AppRoutesName.SUBMISSIONS_FORMAT_LIVE_EDIT_DETAILS, AppRoutesName.SUBMISSIONS_FORMAT_DETAILS, AppRoutesName.SUBMISSIONS_SUPPORT_REVIEW, AppRoutesName.SUBMISSION_SUCCESS, AppRoutesName.REACTIVATE_FONT_FAMILIES],
        tabPermission: 'submissions',
        copyParentPermission: false
      },
      {
        title: 'components.general.fou_side_navigation.manage_fonts.promotions',
        uri: ROUTES.PROMOTION.path,
        linkedRoutes: [AppRoutesName.PROMOTION_DASHBAORD, AppRoutesName.NEW_PROMOTION, AppRoutesName.EDIT_PROMOTION, AppRoutesName.VIEW_PROMOTION, AppRoutesName.PROMOTION_SUCCESS],
        routeName: ROUTES.PROMOTION.name,
        tabPermission: 'promotions',
        copyParentPermission: false
      },
      {
        title: 'components.general.fou_side_navigation.manage_fonts.bundles',
        uri: ROUTES.BUNDLE.path,
        linkedRoutes: [AppRoutesName.BUNDLE_DASHBOARD, AppRoutesName.BUNDLE_SUBMISSION_DRAFT, AppRoutesName.BUNDLE_SUCCESS],
        routeName: ROUTES.BUNDLE.name,
        tabPermission: 'bundles',
        copyParentPermission: false
      },
    ]
  },
  // Manage Earnings
  {
    name: 'Manage Earnings',
    title: 'components.general.fou_side_navigation.manage_earnings.title',
    relatedRouteName: [AppRoutesName.QUARTERLY_STATEMENTS, ROUTES.EARNINGS_REPORT.name, ROUTES.PAYMENTS.name, ROUTES.PAYMENT_ACCOUNT.name],
    linkedRoutes: [
      AppRoutesName.QUARTERLY_STATEMENTS,
      ROUTES.EARNINGS_REPORT.name,
      AppRoutesName.PAYMENT_DASHBOARD,
      AppRoutesName.PAYMENT_ACCOUNT,
      AppRoutesName.PAYMENT_ACCOUNTS_EDIT_MANAGE,
      AppRoutesName.PAYMENT_ACCOUNTS_NEW_MANAGE,
      AppRoutesName.PAYMENT_ACCOUNTS_ERROR,
      AppRoutesName.PAYMENT_ACCOUNT_SUCCESS
    ],
    icon: ICONS.EARNINGS_REPORTS,
    roles: allNonSupportRoles,
    tabPermission: ['salesReport', 'payments'],
    isOpen: false,
    disabledIfGracePeriodExpired: true,
    childRoutes: [
      {
        title: 'components.general.fou_side_navigation.manage_earnings.quarterly_royalties',
        uri: AppRoutesUrl.QUARTERLY_STATEMENTS,
        routeName: AppRoutesName.QUARTERLY_STATEMENTS,
        linkedRoutes: [AppRoutesName.QUARTERLY_STATEMENTS],
        tabPermission: 'salesReport',
        copyParentPermission: false
      },
      {
        title: 'components.general.fou_side_navigation.manage_earnings.earnings_dashboard',
        uri: ROUTES.EARNINGS_REPORT.path,
        routeName: ROUTES.EARNINGS_REPORT.name,
        linkedRoutes: [ROUTES.EARNINGS_REPORT.name],
        tabPermission: 'salesReport',
        copyParentPermission: false
      },
      {
        title: 'components.general.fou_side_navigation.manage_earnings.payments_dashboard',
        uri: ROUTES.PAYMENTS.path,
        routeName: ROUTES.PAYMENTS.name,
        linkedRoutes: [AppRoutesName.PAYMENT_DASHBOARD],
        tabPermission: 'payments',
        copyParentPermission: false
      },
      {
        title: 'components.general.fou_side_navigation.manage_earnings.payment_accounts',
        uri: ROUTES.PAYMENT_ACCOUNT.path,
        routeName: ROUTES.PAYMENT_ACCOUNT.name,
        linkedRoutes: [
          AppRoutesName.PAYMENT_ACCOUNT,
          AppRoutesName.PAYMENT_ACCOUNTS_EDIT_MANAGE,
          AppRoutesName.PAYMENT_ACCOUNTS_NEW_MANAGE,
          AppRoutesName.PAYMENT_ACCOUNTS_ERROR,
          AppRoutesName.PAYMENT_ACCOUNT_SUCCESS
        ],
        tabPermission: 'payments',
        copyParentPermission: false
      }
    ]
  },
  // Agreements
  {
    name: 'Agreements',
    title: 'components.general.fou_side_navigation.agreements',
    uri: ROUTES.AGGREMENTS.path,
    relatedRouteName: [ROUTES.AGGREMENTS.name],
    linkedRoutes: [AppRoutesName.AGGREMENTS, AppRoutesName.PRINT_AGREEMENT, AppRoutesName.AGREEMENT_STATUS, AppRoutesName.SIGN_AGREEMENT],
    icon: ICONS.AGREEMENTS,
    isOpen: false,
    roles: allNonSupportRoles,
    tabPermission: 'agreements'
  },
  // Profile
  {
    name: 'Profile',
    title: 'components.general.fou_side_navigation.profile.title',
    relatedRouteName: [ROUTES.FOUNDRY_PROFILE.name, ROUTES.USER_PERMISSIONS.name],
    linkedRoutes: [AppRoutesName.FOUNDRY_PROFILE, AppRoutesName.EDIT_FOUNDRY, AppRoutesName.FOUNDRY_UPDATE_SUCCESS, AppRoutesName.USER_PERMISSIONS],
    icon: ICONS.PROFILE,
    isOpen: false,
    roles: allNonSupportRoles,
    tabPermission: ['Foundry Profile', 'User Management'],
    disabledIfContractTermination: true,
    childRoutes: [
      {
        title: 'components.general.fou_side_navigation.profile.foundry_info',
        uri: ROUTES.FOUNDRY_PROFILE.path,
        linkedRoutes: [AppRoutesName.FOUNDRY_PROFILE, AppRoutesName.EDIT_FOUNDRY, AppRoutesName.FOUNDRY_UPDATE_SUCCESS],
        routeName: ROUTES.FOUNDRY_PROFILE.name,
        tabPermission: 'Foundry Profile',
        copyParentPermission: false
      },
      {
        title: 'components.general.fou_side_navigation.profile.user_management',
        uri: ROUTES.USER_PERMISSIONS.path,
        linkedRoutes: [AppRoutesName.USER_PERMISSIONS],
        routeName: ROUTES.USER_PERMISSIONS.name,
        tabPermission: 'User Management',
        copyParentPermission: false
      }
    ]
  },
  // Resources
  {
    name: 'Resources',
    title: 'components.general.fou_side_navigation.resources.title',
    relatedRouteName: [ROUTES.ARTICLES.name, ROUTES.VIDEOS.name, ROUTES.EVENTS.name, ROUTES.TEAMS.name, AppRoutesName.NON_UFDA2],
    linkedRoutes: [AppRoutesName.NON_UFDA2],
    icon: ICONS.RESOURCE,
    isOpen: false,
    roles: allNonSupportRoles,
    tabPermission: ['submissions', 'bundles', 'promotions', 'salesReport', 'payments', 'agreements', 'Foundry Profile', 'User Management'],
    disabledIfContractTermination: false,
    childRoutes: [
      {
        title: 'components.general.fou_side_navigation.resources.articles',
        uri: ROUTES.ARTICLES.path,
        uriNonUfda2: ROUTES.NON_UFDA2.articles.path,
        linkedRoutes: [AppRoutesName.NON_UFDA2, 'articles'],
        routeName: ROUTES.ARTICLES.name,
        copyParentPermission: true
      },
      {
        title: 'components.general.fou_side_navigation.resources.videos',
        uri: ROUTES.VIDEOS.path,
        uriNonUfda2: ROUTES.NON_UFDA2.videos.path,
        linkedRoutes: [AppRoutesName.NON_UFDA2, 'videos'],
        routeName: ROUTES.VIDEOS.name,
        copyParentPermission: true
      },
      {
        title: 'components.general.fou_side_navigation.resources.events',
        uri: ROUTES.EVENTS.path,
        uriNonUfda2: ROUTES.NON_UFDA2.events.path,
        linkedRoutes: [AppRoutesName.NON_UFDA2, 'events'],
        routeName: ROUTES.EVENTS.name,
        copyParentPermission: true
      },
      {
        title: 'components.general.fou_side_navigation.resources.teams',
        uri: ROUTES.TEAMS.path,
        linkedRoutes: [AppRoutesName.NON_UFDA2, 'teams'],
        routeName: ROUTES.TEAMS.name,
        copyParentPermission: true
      },
    ]
  },
  {
    name: 'Inventory Hub',
    title: 'components.general.fou_side_navigation.inventory_ingestion_hub',
    uri: ROUTES.INVENTORY_INGESTION_HUB.path,
    relatedRouteName: [ROUTES.INVENTORY_INGESTION_HUB.name, AppRoutesName.INVENTORY_INGESTION_CREATE],
    linkedRoutes: [],
    icon: ICONS.INVENTORY_INGESTION_HUB,
    isOpen: false,
    roles: ['foundrySupport', 'bulkIngestionUser'],
    tabPermission: 'inventory ingestion hub'
  },
  {
    name: 'DropShip',
    title: 'components.general.fou_side_navigation.dropship',
    uri: ROUTES.DROPSHIP.path,
    relatedRouteName: [ROUTES.DROPSHIP.name, AppRoutesName.UPLOAD_FLIP_FONTS],
    linkedRoutes: [ROUTES.DROPSHIP.name, AppRoutesName.UPLOAD_FLIP_FONTS],
    icon: ICONS.DROPSHIP,
    isOpen: false,
    roles: ['foundrySupport', 'dropShipUser'],
    tabPermission: 'dropShip',
    featureName: FEATURE_NAMES.DROP_SHIP
  },
  //Impersonate
  {
    name: 'Impersonate',
    title: 'components.general.fou_side_navigation.impersonate',
    uri: ROUTES.IMPERSONATE.path,
    relatedRouteName: [ROUTES.IMPERSONATE.name],
    linkedRoutes: [ROUTES.IMPERSONATE.name],
    icon: ICONS.IMPERSONATE,
    isOpen: false,
    roles: ['foundrySupport'],
    tabPermission: 'impersonate'
  },
  {
    name: 'Quarterly Earnings Upload',
    title: 'components.general.fou_side_navigation.quarterly_earnings_upload',
    uri: ROUTES.QUARTERLY_EARNINGS_UPLOAD.path,
    relatedRouteName: [ROUTES.QUARTERLY_EARNINGS_UPLOAD.name],
    linkedRoutes: [ROUTES.QUARTERLY_EARNINGS_UPLOAD.name],
    icon: ICONS.SUBSCRIPTION,
    isOpen: false,
    roles: ['foundrySupport'],
    tabPermission: 'quarterlyEarningsUpload'
  },
  {
    name: 'Promotions',
    title: 'components.general.fou_side_navigation.promotions',
    uri: ROUTES.PROMOTION.path,
    relatedRouteName: [ROUTES.PROMOTION.name, AppRoutesName.PROMOTION_DASHBAORD, AppRoutesName.NEW_PROMOTION, AppRoutesName.EDIT_PROMOTION, AppRoutesName.VIEW_PROMOTION, AppRoutesName.PROMOTION_SUCCESS],
    linkedRoutes: [AppRoutesName.PROMOTION_DASHBAORD, AppRoutesName.NEW_PROMOTION, AppRoutesName.EDIT_PROMOTION, AppRoutesName.VIEW_PROMOTION, AppRoutesName.PROMOTION_SUCCESS],
    icon: ICONS.PROMOTIONS,
    isOpen: false,
    roles: ['foundrySupport'],
    tabPermission: 'promotions'
  },
  {
    name: 'MFP Numbers',
    title: 'components.general.fou_side_navigation.mfp_numbers',
    uri: ROUTES.MFP_NUMBERS.path,
    relatedRouteName: [ROUTES.MFP_NUMBERS.name],
    linkedRoutes: [ROUTES.MFP_NUMBERS.name],
    icon: ICONS.MFP_NUMBERS_ICON,
    isOpen: false,
    roles: ['foundrySupport'],
    tabPermission: 'mfpNumbers'
  },
]
